<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Copy Template"
    maxWidth="500px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn icon depressed color="primary" @click="closeModal">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="form" class="mt-4">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="newName"
              label="New Template Name *"
              outlined
              autofocus
              :rules="[Required('New Template Name')]"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <v-row>
        <v-col cols="6">
          <v-btn block depressed color="primary" @click="handleCopy">
            Copy
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn block depressed outlined @click="closeModal">
            Cancel
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DynamicModal>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import Required from '@/lib/formValidations/required'

export default {
  components: {
    DynamicModal
  },
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModalProp: true,
      newName: `${this.template.name} (Copy)`
    }
  },
  methods: {
    Required,
    closeModal () {
      this.showModalProp = false
      this.$emit('close')
    },
    handleCopy () {
      if (!this.$refs.form.validate()) return
      this.$emit('copied', this.newName)
    }
  }
}
</script>
